import account, { hasSection } from '../data/account';
import { hasTenantFeature, hasCampaignDashboards, autopilotHiddenHere } from '../functions/tenant-features';
import { canViewQuotes } from '../views/sales/sales-quotes-api';
import { resolveBusinessModel } from '../views/sales/territory-common';

/*
 * What the signed-in member can open — the SAME rules layout/menu-items.jsx
 * uses to show nav entries, so search never offers (or fetches) a page the nav
 * hides. Resolved once per search run: the business model is async (boot
 * config first, so it is immediate after the first call — territory-common
 * caches it per tenant).
 */
export async function searchAccess() {
  const acct = account.get() || {};
  let bm = 'both';
  try {
    bm = await resolveBusinessModel();
  } catch (e) {/* nav falls back to both too */}
  const groups = acct.groups || [];
  const salesGroups = groups.map(g => String(g).toLowerCase());
  const manufacturer = bm === 'manufacturing' || bm === 'both';
  const showCampaigns = Boolean(acct.showCampaigns) || hasTenantFeature('campaigns');
  const showContacts = !showCampaigns || hasTenantFeature('socialStats');
  return {
    groups,
    bm,
    sales: hasSection('sales', groups),
    marketing: hasSection('marketing', groups),
    cockpit: (hasTenantFeature('salesTransactions') || hasTenantFeature('territoryRep')) && ['owner', 'administrator', 'root', 'sales'].some(g => salesGroups.includes(g)),
    territory: hasTenantFeature('territoryRep') && manufacturer,
    stores: hasTenantFeature('storePerformance') && (bm === 'retail' || bm === 'both'),
    quotes: hasTenantFeature('quotes') && manufacturer && canViewQuotes(),
    campaigns: hasCampaignDashboards(),
    autopilot: !autopilotHiddenHere(),
    email: hasTenantFeature('emailAutomation'),
    social: hasTenantFeature('socialStats'),
    contentHub: hasTenantFeature('contentHub'),
    contacts: showContacts,
    customers: hasTenantFeature('lifecycle'),
    reports: hasTenantFeature('customReports'),
    // Inside the Customers group the account page is "Dealers" (wholesale) or "Accounts" (retail).
    accountsLabel: bm === 'retail' ? 'Accounts' : 'Dealers'
  };
}

// A source is searched only when its Commerce section AND its nav gate allow it.
export function sourceAvailable(config, access) {
  if (!config) return false;
  if (config.section && !(access ? access[config.section] : hasSection(config.section, (account.get() || {}).groups))) return false;
  if (config.enabled && !config.enabled(access || {})) return false;
  return true;
}
export default searchAccess;